﻿const accordion = () => {
  const openCssClass = "grid-rows-open",
    collapsedCssClass = "grid-rows-closed";

  const sections = document.querySelectorAll(
    "[data-accordion-section]"
  ) as NodeListOf<HTMLElement>;

  sections.forEach(section => {
    const trigger = section.querySelector<HTMLButtonElement>("[data-section-heading]");

    if (!trigger) {
      console.error("Unable to find accordion trigger");

      return;
    }

    trigger.onclick = event => {
      const clickedElement = event.target as HTMLElement;

      let clickedSection: HTMLElement;

      if (clickedElement.hasAttribute("data-accordion-section")) {
        clickedSection = clickedElement;
      } else {
        clickedSection = clickedElement.closest("[data-accordion-section") as HTMLElement;
      }

      const sectionContent = clickedSection.querySelector(
        "[data-accordion-section-content]"
      ) as HTMLElement;

      const isCollapsed = sectionContent.classList.contains(collapsedCssClass);

      if (isCollapsed) {
        // Expand
        sectionContent.classList.remove(collapsedCssClass);
        sectionContent.classList.add(openCssClass);
        trigger.ariaExpanded = "true";
      } else {
        // Collapse
        sectionContent.classList.add(collapsedCssClass);
        sectionContent.classList.remove(openCssClass);
        trigger.ariaExpanded = "false";
      }
    };

    // Ensure links are still clickable without trigger expand/collapse
    section.querySelectorAll<HTMLAnchorElement>("a").forEach(a => {
      a.onclick = event => {
        event.stopPropagation();
      };
    });
  });
};

accordion();
